<template lang="html">
  <img class="pt-3 mb-4" src="@/assets/logo.svg" alt="logo" width="250" />
  <div class="container-fluid">
    <h1 class="title">Which theme should definitely be chosen in future?</h1>
    <div class="d-grid gap-2">
      <textarea
        v-model="openAnswer"
        class="form-control form-control-lg rounded-0 field"
        rows="6"
        placeholder="Type your answer here..."
      ></textarea>

      <button
        type="button"
        class="btn btn-primary btn-lg rounded-pill"
        @click="saveAndGetQrCode()"
        :disabled="!isValidAnswer"
      >
        <span>Next</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuestionFourScreen",
  data: () => ({
    openAnswer: "",
  }),
  computed: {
    isValidAnswer() {
      return this.openAnswer.trim().length > 0;
    },
  },
  methods: {
    saveAndGetQrCode() {
      this.$store.commit("setQuestionFour", this.openAnswer.trim());
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/custom.scss";

.field::placeholder {
  color: $info;
}
</style>
